import { getPublicWorkouts, getPlaceholderImages } from '@/api/requests';
import router from '../../router';
import Vue from 'vue';

const state = {
  workouts: [],
  selectedWorkout: {},
  selectedPlaceholder: false,
  createWorkout: false,
  pushPlaceholder: '',
  pullPlaceholder: '',
  legsPlaceholder: '',
  fullbodyPlaceholder: '',
};

const mutations = {
  updateAttribute(state, payload) {
    state[payload.type] = payload.value;
  },

  clearWorkouts(state) {
    state.selectedWorkout = {};
    state.workouts = [];
    state.createWorkout = false;
  },

  setWorkouts(state, workouts) {
    state.selectedWorkout = {};
    const newArray = state.workouts.concat(workouts);
    state.workouts = newArray;
    state.createWorkout = false;
  },

  setOriginalValue(state, workouts) {
    state.selectedWorkout = {};
    state.workouts = workouts
  },

  loadMore(state, workouts) {
    state.workouts = state.workouts.concat(workouts);
  },

  setPlaceholderImages(state, placeholderImages) {
    state.pushPlaceholder = placeholderImages.push_image;
    state.pullPlaceholder = placeholderImages.pull_image;
    state.legsPlaceholder = placeholderImages.legs_image;
    state.fullbodyPlaceholder = placeholderImages.fullbody_image;
  },

  setSelectedWorkout(state, workout) {
    state.selectedWorkout = workout;
    state.selectedPlaceholder = false;
    state.createWorkout = false;
  },

  clearSelectedWorkout(state) {
    state.selectedWorkout = {};
    state.selectedPlaceholder = false;
  },

  setSelectedPlaceholderImage(state) {
    state.selectedPlaceholder = true;
    state.selectedWorkout = {};
  },

  updateWorkout(state, workout) {
    if (workout?.title) state.editWorkout.title = workout.title;

    let storedWorkout = state.workouts.find(w => w.id === workout.id);
    let index = state.workouts.indexOf(storedWorkout);
    Vue.set(state.workouts, index, state.editWorkout);
  },

  addWorkout(state, workout) {
    if (state.workouts) {
      Vue.set(state.workouts, state.workouts.length, workout);
    } else {
      state.workouts = [];
      Vue.set(state.workouts, state.workouts.length, workout);
    }
    state.selectedWorkout = workout;
  },

  removeWorkout(state, id) {
    let workout = state.workouts.find(w => w.id === id);
    let index = state.workouts.indexOf(workout);
    state.workouts.splice(index, 1);

    Vue.set(state, 'workouts', state.workouts);
  },

  setEditWorkout(state, workout) {
    state.editWorkout = workout;
    state.createWorkout = true;
  },

  cancelWorkoutModify(state) {
    state.selectedWorkout = {};
    state.createWorkout = false;
  }
};

const actions = {
  clearWorkouts(context) {
    context.commit('clearWorkouts');
  },

  loadWorkouts(context, params) {
    getPublicWorkouts(params).then(response => {
      context.commit('setWorkouts', response.data.data);
    });
  },

  loadPlaceholderImages(context) {
    getPlaceholderImages().then(response => {
      context.commit('setPlaceholderImages', response.data);
    });
  },

  placeholderImagesClicked(context) {
    context.commit('setSelectedPlaceholderImage');
  },

  workoutClicked(context, workout) {
    context.commit('setSelectedWorkout', workout);
  },

  newWorkoutClicked(context) {
    context.commit('clearSelectedWorkout');
  },

  editWorkoutClicked(context, workout) {
    context.commit('setEditWorkout', workout);
  },

  cancelWorkoutModify(context) {
    context.commit('cancelWorkoutModify');
  },
};

const getters = {

};

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};